<template>
  <div class='bottom-style'>
    <div>
    <!-- 底部工信部链接 -->
    <span>Copyright ©  上海缘起网络技术有限公司版权所有|
          <a href="https://beian.miit.gov.cn/" target='_blank'>沪ICP备11003447号-1</a> <span> | </span> <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=31011702890856" rel="noreferrer" target="_blank">
        <img :src="ga" style="width: 20px;height: 20px" alt="a" /> 沪公网安备31011702890856号</a>
      <br>
       <div style="padding-top: 3px">地址: 上海市松江区千帆路237弄8号楼807室</div>
    </span>
    </div>
  </div>

</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

const ga = require('../../assets/img.png')
const route = useRoute()
const store = useStore()
const name = ref(store.getters.userInfo.name)
</script>

<style lang="scss" scoped>
.bottom-style{
  width: 100%; height: 130px;
  display: grid;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  background: $background-color-primary;
}
</style>
